import React from "react";
import Image from "next/image";

const VerticalDivider = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1"
    height="302"
    viewBox="0 0 1 302"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M0.774362 169.162C0.706874 175.828 0.987551 181.076 0.932959 189.2C0.879217 197.325 0.738352 198.542 0.755065 207.846C0.76702 217.151 0.665266 226.46 0.704212 230.603C0.739078 234.746 0.603867 235.183 0.623026 241.066C0.639219 246.949 0.611516 250.514 0.569678 255.659C0.524082 260.804 0.49656 276.611 0.506412 282.359C0.51071 288.107 0.47215 294.663 0.47168 298.606C0.470175 299.834 0.469267 300.8 0.468911 301.541C0.468748 301.855 0.468733 302 0.468737 302C0.468752 302 0.46867 301.775 0.468448 301.372C0.467295 299.414 0.46598 296.487 0.454339 293.03C0.427374 286.583 0.445702 285.879 0.418208 277.174C0.38873 268.469 0.317992 263.239 0.328086 252.997C0.352419 242.755 0.150617 240.402 0.231415 225.944C0.335729 211.486 0.0893759 209.965 0.0180053 195.557C-0.0514208 181.15 0.100692 162.963 0.0880503 154.278C0.086262 153.227 0.0842098 152.133 0.0820806 151C0.0662781 142.762 0.0482846 132.439 0.0934865 121.616C0.14094 109.304 0.0793048 94.1045 0.17182 80.5138C0.261208 66.9233 0.359623 47.7091 0.397863 38.8323C0.438136 29.956 0.437329 27.7924 0.439841 19.2485C0.441168 14.3373 0.462249 7.5717 0.467663 1.85698C0.470158 -1.01904 0.467095 -0.367336 0.471254 2.52747C0.477978 6.76063 0.479363 10.2356 0.493397 12.4168C0.523626 16.7752 0.552846 18.6276 0.546838 24.1297C0.535413 29.6316 0.606407 32.2241 0.61197 35.4314C0.616119 38.6389 0.56283 38.5861 0.647571 54.8943C0.739916 71.2028 0.784577 80.1432 0.8142 86.3191C0.847704 92.495 0.79022 105.391 0.831256 115.456C0.871422 124.384 0.862781 141.491 0.894388 151C0.898592 152.211 0.903586 153.3 0.909629 154.232C0.962475 162.48 0.842809 162.497 0.774362 169.162Z"
      fill="#ADADAD"
    />
  </svg>
);

const examPatternCards = [
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/two_parts.webp",
    imageMobile:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/two_parts_mobile.webp",
    caption:
      "Two parts, each with 100 MCQ-type questions and 2 essay-type questions",
  },
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/4_hours.webp",
    imageMobile:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/4_hours_mobile.webp",
    caption: "4 hours per part: 3 hours for the MCQ section, 1 hour for essays",
  },
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/worldwide.webp",
    imageMobile:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/worldwide_mobile.webp",
    caption: "Exams conducted at Prometric Testing Centers worldwide",
  },
];

const CmaCoursePattern = () => {
  return (
    <section className="w-full bg-[#F6F6F6] md:py-[50px] max-md:bg-[#F3F3F3]">
      <div className="main_container">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-[1fr_1px_1fr] md:gap-8">
          {/* Exam Pattern */}
          <div className="max-md:bg-white max-md:rounded-2xl max-md:px-4 max-md:py-4">
            <h2 className="md:text-[32px] text-[24px] font-bold leading-normal text-left md:text-left md:mb-6 mb-4">
              <span className="text-[#39F]">CMA Course:</span>
              <span className="text-[#333]"> Exam Pattern</span>
            </h2>

            <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-2">
              {examPatternCards?.map((card, idx) => (
                <div
                  key={card.caption}
                  className={`relative overflow-hidden rounded-[8px] md:h-[240px] ${
                    idx === 0
                      ? "max-md:col-span-2 max-md:h-[150px]"
                      : "max-md:h-[190px]"
                  }`}
                >
                  <Image
                    src={card.image}
                    alt={card.caption}
                    fill
                    sizes="200px"
                    className="object-cover object-top max-md:hidden"
                    loading="lazy"
                  />
                  <Image
                    src={card.imageMobile}
                    alt={card.caption}
                    fill
                    sizes={idx === 0 ? "100vw" : "50vw"}
                    className="object-cover object-top md:hidden"
                    loading="lazy"
                  />
                  <p className="absolute bottom-0 left-0 w-full text-white text-sm font-normal leading-[1.4] px-3 py-2.5">
                    {card.caption}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div className="hidden md:flex items-center justify-center">
            <VerticalDivider />
          </div>

          {/* Duration */}
          <div className="max-md:bg-white max-md:rounded-2xl max-md:px-4 max-md:py-4 md:mb-0 mb-4">
            <h2 className="md:text-[32px] text-[24px] font-bold leading-[1.2] text-left md:text-left md:mb-6 mb-4">
              <span className="text-[#39F]">CMA Course</span>
              <span className="text-[#333]"> Duration</span>
            </h2>

            <p className="text-[#333] md:text-sm text-sm font-normal leading-normal tracking-[-0.42px] text-left md:text-left md:mb-5 mb-4">
              One of the most-asked questions about the CMA course is simple:
              how long does it actually take? The Certified Management
              Accountant course can typically be completed within 8–12 months,
              depending on your pace of study, with IMA giving you the
              flexibility to plan around work and personal commitments.
            </p>
            <p className="text-[#333] md:text-sm text-sm font-normal leading-normal tracking-[-0.42px] text-left md:text-left">
              The course builds progressively: you prepare for and sit Part 1,
              then Part 2, with results announced after each attempt. Most
              working professionals following a structured plan like Miles&apos;
              guided CMA classes finish both parts inside this window, making{" "}
              <a
                href="https://www.mileseducation.com/blog/accounting/cma-usa-course-duration"
                target="_blank"
                className="text-[#39F] underline"
              >
                CMA course duration
              </a>{" "}
              one of the shortest among globally recognized finance
              certifications.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CmaCoursePattern;
